import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

export const ProductListList = () => {
  const { dataGridProps } = useDataGrid();

  const columns = React.useMemo<GridColDef<any>[]>(
    () => [
      {
        field: "code",
        headerName: "code",
        type: "number",
        minWidth: 200,
      },
      {
        field: "name",
        headerName: "Name",
        type: "string",
        minWidth: 200,
      },
      {
        field: "name_ar",
        headerName: "Name Arabic",
        type: "string",
        minWidth: 200,
      },
    ],
    []
  );

  return (
    <List canCreate={false}>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
